import { forwardRef, type Ref, type SVGProps } from "react";
const IconFolderFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 7H15.46l-1.7-2.55a1 1 0 0 0-.83-.45H4a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2m-3 6H14.41L13 14.41a2 2 0 0 1-1.41.59H7a1 1 0 0 1 0-2h4.59L13 11.59a2 2 0 0 1 1.41-.59H25a1 1 0 0 1 0 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFolderFilledSVG);
ForwardRef.displayName = "IconFolderFilled";
export { ForwardRef as IconFolderFilled };
